// Open modals must survive Turbo page morphs happening beneath them
// (turbo_stream.refresh — today only triggered by saves, one day by
// broadcasts). Three pieces, all scoped to "while a modal is shown":
//
// 1. The modal element is data-turbo-permanent while shown: idiomorph skips
//    permanent elements entirely (never morphed, never removed), so the open
//    modal and all its client-side form state ride the morph out unharmed.
//    The attribute comes off on hidden.bs.modal — leftover modal DOM in the
//    remote_modal frame must stay morphable/replaceable once closed.
//    (Which modals still close on a render is decided elsewhere: see
//    lib/modal_submit_mark.js and base_modal.js#_hideBeforeRender.)
//
// 2. An open modal's supporting DOM also lives outside the server-rendered
//    HTML, so a morph would remove it: Bootstrap's backdrop, plus the
//    dropdown panels widgets mount at body level (slim-select's .ss-content,
//    flatpickr's calendar). Mark them permanent while their modal is shown —
//    Bootstrap removes the backdrop itself on hide and the widgets remove
//    their panels on teardown, so nothing unmorphable lingers. Backdrops are
//    created after show.bs.modal dispatches, hence the marking on
//    shown.bs.modal, re-asserted on turbo:before-render to cover a morph
//    landing mid fade-in (and to catch panels created since).
//
// 3. Bootstrap's scroll lock (body.modal-open + inline overflow/padding)
//    also lives outside the server HTML — a morph would strip it and unlock
//    scrolling under the open modal. Cancel body class/style attribute
//    morphs while any modal chrome is up; Bootstrap restores body state
//    itself when the last modal closes.
//
// Offcanvas sidebars need the same treatment as (3), for the same reason.
// The #right_sidebar frame is refresh="morph", so a page morph reloads it
// and morphs the offcanvas in place: idiomorph matches the element by id and
// syncs its attributes down to the server HTML, which carries neither
// Bootstrap's .show class nor the resizer's inline width. The element is
// preserved rather than replaced, so Stimulus never reconnects to re-show it
// and Bootstrap still believes it is open — the sidebar is invisible and
// stuck. Cancel class/style morphs on a *shown* offcanvas only; its contents
// must keep morphing (that is the point of the refresh), and an offcanvas
// that is legitimately closing has already lost .show by then.

document.addEventListener("show.bs.modal", (event) => {
  event.target.setAttribute("data-turbo-permanent", "")
})

document.addEventListener("hidden.bs.modal", (event) => {
  event.target.removeAttribute("data-turbo-permanent")
})

function markPermanent(element) {
  element.setAttribute("data-turbo-permanent", "")
}

function markModalChromePermanent() {
  document.querySelectorAll(".modal-backdrop").forEach(markPermanent)

  document.querySelectorAll(".modal.show").forEach((modal) => {
    // slim-select mounts its dropdown panel at body level; match it back to
    // the enhanced select inside the open modal via the shared data-id.
    modal.querySelectorAll("select").forEach((select) => {
      const id = select.slimSelect?.settings?.id
      const content = id && document.querySelector(`.ss-content[data-id='${id}']`)
      if (content) { markPermanent(content) }
    })

    // flatpickr also mounts its calendar at body level.
    modal.querySelectorAll("input").forEach((input) => {
      const calendar = input._flatpickr?.calendarContainer
      if (calendar) { markPermanent(calendar) }
    })
  })
}

document.addEventListener("shown.bs.modal", markModalChromePermanent)
document.addEventListener("turbo:before-render", markModalChromePermanent)

document.addEventListener("turbo:before-morph-attribute", (event) => {
  if (event.target !== document.body) { return }
  if (!["class", "style"].includes(event.detail.attributeName)) { return }

  // .modal-backdrop covers the fade-in window before .show lands.
  if (document.querySelector(".modal.show, .modal-backdrop")) {
    event.preventDefault()
  }
})

document.addEventListener("turbo:before-morph-attribute", (event) => {
  if (!["class", "style"].includes(event.detail.attributeName)) { return }

  if (event.target.matches?.(".offcanvas.show")) {
    event.preventDefault()
  }
})
